module.exports = "/assets/f0b60c1e58416928e22c06c763e2170f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/K7.png
// module id = 1535
// module chunks = 0